<script>
  import { page } from "$app/stores";
  import Seo from "$lib/components/SEO.svelte";
  import FreeformPageTemplate from "$lib/pageTemplates/FreeformPageTemplate.svelte";

  const PAGE_DATA = {
    fields: {
      headline: "404 Page"
    }
  };

  $: currentUrl = $page.error.url;
</script>

<Seo data={PAGE_DATA.fields} {currentUrl} errorPage />

{#if $page.error.pageData}
  <FreeformPageTemplate page={$page.error.pageData} />
{:else}
  <!-- We really don't want this to happen, but what if they move the error page? -->
  <div class="w-full lg:w-1/2 mx-auto">
    <div class="text-center heading-3">
      Oops, an error has occurred.
      {$page.error.message}: {currentUrl}
    </div>
  </div>
{/if}
